import { Suspense } from "react";
import { AuthLoadingFullscreen } from "./auth-screens";
import { FirstRunWizard } from "./lazy-imports";
import type { UseFirstRunGateResult } from "./use-first-run-gate";

interface FirstRunGateProps {
  firstRun: UseFirstRunGateResult;
  /** Navigate the app into the freshly-created workspace at Finish. */
  onCreated: (workspaceId: string) => void;
}

/**
 * Render-only boot surface for a non-returning user. Mounted EXCLUSIVELY by
 * `AppInner` (instead of `AppShell`) so the app shell never paints for someone
 * who's about to be onboarded — that's what kills the workspace/Home flash.
 *
 * Both states render the SAME `AuthLoadingFullscreen` cover the AuthGate +
 * bootstrap gates already show, so the boot is one continuous cover from
 * sign-in all the way to the wizard — never a hard cut between surfaces. The
 * wizard chunk loads lazily behind that identical cover (Suspense fallback).
 */
export function FirstRunGate({ firstRun, onCreated }: FirstRunGateProps) {
  if (firstRun.gate.kind === "onboarding") {
    return (
      <Suspense fallback={<AuthLoadingFullscreen />}>
        <FirstRunWizard
          {...firstRun.gate.seeds}
          onFinishStart={firstRun.onFinishStart}
          onFinishEnd={firstRun.onFinishEnd}
          onCreated={onCreated}
          onDismiss={firstRun.onDismiss}
        />
      </Suspense>
    );
  }
  // kind === "cover" — the boot cover, identical to the gates above us.
  return <AuthLoadingFullscreen />;
}
